<template>

    <div class="user">
    
  
      
        <div style="width:100%;border: 1px solid #f7f7f7;float: left;height: 550px;overflow-y: auto;padding: 10px; ">
          <el-form :inline="true" size="small"  class="demo-form-inline">
         
            <el-form-item >
              <el-input style="width: 45%;float: left;" placeholder="请输入商家名称" v-model="supply_search">
            
             </el-input>
              <el-button  style="width: 25%;float: left;margin-left: 2%;" type="primary" icon="el-icon" @click="getSupply">查询</el-button>
              <el-button  style="width: 25%;float: left;margin-left: 2%;background: #999;border: 1px solid #999;" type="primary" icon="el-icon" @click="reast">重置</el-button>
              <div style="clear: both;"></div>
            </el-form-item>
  
        </el-form>  
          
          
        <el-table
              ref="singleTable"
              :data="supplyList"
              highlight-current-row
              @current-change="handleCurrentChange"
              border
              style="width: 100%">
              <el-table-column
                property="supply_id"
                label="ID"
                width="80">
              </el-table-column>
              <el-table-column
                property="name"
                label="名称">
              </el-table-column>
              
            </el-table>
    </div>
      
    

    
    </div>
  </template>
  
  <script>

    import SupplyApi from '@/api/supply.js';
 
  
    export default {

      inject: ['reload'],
      data() {
        return {
        
  
  
          supply_search:"",
          supplyList:[],
          currentRow :null
        };
      },
      created() {
        this.getSupply();
 
      },
      methods: {
        handleCurrentChange(val) {
    
            this.currentRow = val;
            this.$emit("handleCurrentChange", { openDialog: false,"id":val.supply_id });
      },
      reast() {
    
                this.currentRow = null;
                this.$emit("reast", { openDialog: false,"id":0 });
            },
        getSupply() {
            let self = this;
            let params = {
            'name':self.supply_search
            };
            params.page = 1;
            params.list_rows = 9000;
            SupplyApi.supplyList(params, true)
            .then(res => {
                if (res.code == 1) {
                self.loading = false;
                self.supplyList = res.data.list.data
    
                }
            })
            .catch(error => {});
      },
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/components/select/supply.vue